/**
 * 优惠头条接口
 */

import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';

// 获取活动配置
export async function getTags(params = {}) {
  const api = 'api/v1.0/PromotionHeadline/Article/CategoryList';
  const body = await apiProxy.get(api, { params });
  return body.middleware_group__PromotionHeadlineCategoryList.data;
}

export async function getList(params = {}) {
  params = ensureParams(params, getList.__definedParams);
  const api = 'api/v1.0/PromotionHeadline/Article/ArticleList';
  const body = await apiProxy.get(api, { params });
  return body.middleware_group__PromotionHeadlineArticleList.data;
}

getList.__definedParams = {
  catId: '0',
  page: '1',
  pageSize: '15'
};

export async function addShareCount(params = {}) {
  params = ensureParams(params, addShareCount.__definedParams);
  const api = 'api/v1.0/PromotionHeadline/Article/AddShareCount';
  const body = await apiProxy.get(api, { params });
  return body.middleware_group__PromotionHeadlineAddShareCount.data;
}

addShareCount.__definedParams = {
  articleId: '0'
};

export async function like(params = {}) {
  params = ensureParams(params, like.__definedParams);
  const api = 'api/v1.0/PromotionHeadline/Article/Like';
  const body = await apiProxy.get(api, { params });
  return body.middleware_group__PromotionHeadlineArticleLike.data;
}

like.__definedParams = {
  articleId: '0'
};

export async function unlike(params = {}) {
  params = ensureParams(params, unlike.__definedParams);
  const api = 'api/v1.0/PromotionHeadline/Article/Unlike';
  const body = await apiProxy.get(api, { params });
  return body.middleware_group__PromotionHeadlineArticleUnlike.data;
}

unlike.__definedParams = {
  articleId: '0'
};
